import script from "./AccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountView.vue?vue&type=script&setup=true&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=3c895bbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c895bbe"]])

export default __exports__